import { render } from "./TooglePushNotification.vue?vue&type=template&id=545cefaa"
import script from "./TooglePushNotification.vue?vue&type=script&lang=js"
export * from "./TooglePushNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__